import * as yup from 'yup';

export const UserDetailsUpdateSchema = yup.object().shape({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  jobFunction: yup.string().nullable().required('Job Function is required'),
});
